<template>
  <v-container ref="copyContainer" grid-list-xl fluid>
    <v-layout row wrap>
      <v-overlay :value="pageLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-flex v-if="!pageLoading">
        <filter-orders-complex
          :default-search-params="searchParams"
          :is-component-loading="isRequestingNow"
          @filtering="onFilter"
          @download-excel="onDownloadExcel"
          @send-email-excel="onSendEmailExcel"
        ></filter-orders-complex>
        <table-paginated-orders-complex
          :is-component-loading="isRequestingNow"
          :paginated-object="paginatedObject"
          @edit-item="onPaginatedItemEdit"
          @delete-item="onPaginatedItemDelete"
          @clone-item="onPaginatedItemClone"
          @copy-item="onPaginatedItemCopy"
          @preview-item="onPreviewItem"
          @renew="onRenewPaginatedObject"
          class="pa-4"
        ></table-paginated-orders-complex>
        <pagination-listing
          :pagination-data="paginationData"
          @go-prev="changePage('-')"
          @go-next="changePage('+')"
        ></pagination-listing>
      </v-flex>
      <modal-loading :is-show="isTableLoading"></modal-loading>
      <!-- Edit Modal -->
      <edit-modal-order-complex
        :item="currentEditableItem"
        :is-show-dialog="isShowOrderDialog"
        :is-modal-loading="isLoadingOrderDialog"
        :action-label="orderDialogActionLabel"
        :errors="errorsOrderDialog"
        :is-display-subscription-data="true"
        @on-close="onCloseOrderDialog"
        @on-action="onActionOrderComplexDialog"
        @copy-item="onPaginatedItemCopy"
      />
      <v-btn
        color="pink"
        dark
        fixed
        bottom
        right
        fab
        @click="currentEditableItem = {}; isShowOrderDialog = true"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
      <!-- End: Edit Modal -->
      <accept-dialog
        :is-open-dialog="isShowDeleteDialog"
        @on-close="isShowDeleteDialog=false"
        @on-accept="onAcceptDeletion"
      >
        <div class="pt-6">
          {{acceptModalText}}
        </div>
      </accept-dialog>
      <clone-modal
        :order="currentClonableItem"
        @on-close="onCloneModalClose"
        @on-accept="onCloneModalAccept"
      ></clone-modal>
      <preview-popup
        :is-show-popup="previewPopup.show"
        :title="previewPopup.title"
        @on-close="previewPopup.show = false"
      >
        {{previewPopup.content}}
      </preview-popup>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment';
/* constants */
import { PER_PAGE_ORDERS } from '@/constants/listing';
import { DATE_ISO } from '@/constants/dates';
/* proxy */
import OrderComplexOptimizedProxy from '@/proxies/Order/OrderComplexOptimizedProxy';
/* mixins */
import defaultListingMixin from '@/mixins/listing/defaultListingMixin';
import paginationMixin from '@/mixins/listing/paginationMixin';
import updatePageContentMixin from '@/mixins/updatePageContentMixin';
import orderCopyToClipBoardMixin from '@/mixins/orderCopyToClipBoardMixin';
import orderDialog from '@/mixins/orders/orderDialog';
import orderListing from '@/mixins/orders/orderListing';
import downloadReport from '@/mixins/reports/downloadReport';
import sendEmailReport from '@/mixins/reports/sendEmailReport';
/* components */
import EditModalOrderComplex from '@/components/listings/EditModalOrderComplex.vue';
import ModalLoading from '@/components/loaders/ModalLoading.vue';
import PaginationListing from '@/components/listings/PaginationListing.vue';
import TablePaginatedOrdersComplex from '@/components/listings/TablePaginatedOrdersComplex.vue';
import AcceptDialog from '@/components/AcceptDialog.vue';
import FilterOrdersComplex from '@/components/listings/FilterOrdersComplex.vue';
import PreviewPopup from '@/components/PreviewPopup.vue';

export default {
  name: 'OrdersComplex',
  mixins: [
    paginationMixin,
    updatePageContentMixin,
    orderCopyToClipBoardMixin,
    defaultListingMixin,
    orderDialog,
    orderListing,
    downloadReport,
    sendEmailReport,
  ],
  components: {
    ModalLoading,
    EditModalOrderComplex,
    PaginationListing,
    TablePaginatedOrdersComplex,
    AcceptDialog,
    FilterOrdersComplex,
    PreviewPopup,
  },
  data() {
    return {
      reportMethodName: 'ordersComplexListingReport',
      emailReportMethodName: 'ordersComplexListingEmailReport',
      searchParams: {
        page: {
          number: 1,
          size: PER_PAGE_ORDERS,
        },
        search_contact: '',
        search_cleaner: '',
      },
      previewPopup: {
        show: false,
        title: '',
        content: '',
      },
    };
  },
  created() {
    if (this.$route.params.phoneNumber) {
      this.searchParams.search_cleaner = this.$route.params.phoneNumber || '';
      this.searchParams.order_to = 'desc';
      this.searchParams.from = moment()
        .startOf('day')
        .format(DATE_ISO);
    }
  },
  methods: {
    fetchData() {
      this.isRequestingNow = true;
      new OrderComplexOptimizedProxy()
        .setParameters(this.searchParams)
        .all()
        .then((response) => {
          this.paginatedObject = response.data.data.orders;
          this.$forceUpdate();
        })
        .catch((error) => {
          console.warn(error);
          this.paginatedObject = {};
        })
        .finally(() => {
          this.isTableLoading = false;
          this.isRequestingNow = false;
          this.$store.dispatch('page/finishUpdateCurrentPageContent');
        });
    },
    onRenewPaginatedObject(data) {
      if (this.paginatedObject.data.length > 0) {
        this.paginatedObject.data.splice(0);
      }
      this.paginatedObject.data = data.map(item => {
        return item;
      });
    },
  },
};
</script>
